import { z } from 'zod';

export const notificationSettingsSearchSchema = z.object({
    organizationId: z.string().optional(),
    unsubscribeEmailType: z.string().optional(),
    source: z.enum(['activity']).optional(),
    highlight: z.enum(['auto-cleanup']).optional(),
});
